export default {"src":"/_next/static/media/about55.a1e01d37.svg","height":226,"width":260};